import { SemanticTypography } from '../semantic-typography';

export const semanticTypography = {
    primaryFontFamily: 'Inter',
    secondaryFontFamily: 'Inter',
    weightRegular: 'Regular',
    weightMedium: 'Medium',
    weightSemi: 'Semibold',
    weightBold: 'Bold',
    fontSize: {
        headline: 48,
        h1: 32,
        h2: 24,
        h3: 20,
        h4: 16,
        body: 16,
        description: 14,
        descriptionSmall: 12,
    },
} satisfies SemanticTypography;
